<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <!-- 視頻開始 -->
  <div class="hbody is-loading">
    <!-- PC 端轮播（只在电脑渲染） -->
    <div v-if="isPC" class="topSwiper hidden-xs">
      <el-carousel
        v-if="topPCJImage.length"
        :style="{ height: 'calc(100vh - 80px)' }"
        trigger="click"
        arrow="never"
      >
        <el-carousel-item v-for="item in topPCJImage" :key="item.id">
          <h3 class="sImg">
            <img :src="item.url" alt />
          </h3>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 手机端轮播（只在手机渲染） -->
    <div v-else class="topSwiper visible-xs">
      <el-carousel
        v-if="topAZJImage.length"
        :style="{ height: 'calc(100vh - 56px)' }"
        trigger="click"
        arrow="never"
      >
        <el-carousel-item v-for="item in topAZJImage" :key="item.id">
          <h3 class="sImg">
            <img :src="item.url" alt />
          </h3>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 關於開始 -->
    <section id="about">
      <div class="row about-wrap">
        <div class="col-full">
          <div class="about-profile-bg">
            <div class="intro">
              <h3 class="animate-this">会社紹介</h3>
              <p class="lead animate-this" style="text-align: left">
                華胤グループ（Far
                East／かいん）は、鋼構造エンジニアリングと鉄骨製作を中核とする国際的な鋼構造企業です。企画・設計から鉄骨製作、製造、施工、プロジェクト管理まで一貫したサービスを提供し、産業施設、エネルギープラント、物流施設、商業建築など、世界各国の鋼構造プロジェクトに対応しています。<br /><br />当社は、国土交通大臣認定（JSA／日本鉄骨評価センター）を取得した海外鋼構造メーカーとして、日本の建築基準に適合した鉄骨製作が可能です。さらに、AISC、AWS、CWB、CSA
                A660、EN1090などの国際認証を取得し、日本および国際基準に対応した品質管理体制のもと、高品質な鋼構造製品を提供しています。<br />これまでに4,000件以上の鋼構造プロジェクトを世界各地で完成させ、グローバル市場において信頼される鋼構造エンジニアリング企業として事業を展開しています。
              </p>
            </div>
          </div>
        </div>
        <!-- end col-full  -->
      </div>
      <!-- end about-wrap  -->
    </section>
    <!-- 關於結束 -->

    <!-- 榮譽開始 -->
    <div class="new-scheme-main" style="background-color: #e7e7e8">
      <p class="title">国際認証</p>

      <div
        class="full-screen-portfolio"
        id="portfolio"
        style="background-color: #e7e7e8"
      >
        <div class="container-fluid">
          <div
            class="col-lg-2 col-xs-4 ryfox"
            v-for="(item, index) in jtrzList"
            :key="index"
          >
            <div class="portfolio-item">
              <div class="thumb">
                <div class="image">
                  <div class="demo-image__preview">
                    <!-- 👇 懒加载：滚动到才加载图片 -->
                    <el-image
                      class="eImagebc"
                      :src="item.icon"
                      :preview-src-list="item.image"
                      lazy
                    >
                    </el-image>
                  </div>
                </div>
                <div class="hover-effect">
                  <div class="hover-content" style="white-space: pre-line">
                    <h1 class="hidden-xs">{{ item.text }}</h1>
                    <h1 class="visible-xs">{{ item.Atext }}</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 榮譽結束 -->

    <div style="background-color: rgb(231, 231, 232)">
      <to-mail button-text="お問い合わせ"></to-mail>
    </div>
  </div>
  <!-- 榮譽結束 -->
</template>

<script>
export default {
  data() {
    return {
      isPC: true, // 设备判断
      topPCJImage: [
        { url: require('@/components/img/home/Etop1.jpg'), id: 0 },
        { url: require('@/components/img/home/Etop2.jpg'), id: 1 },
        { url: require('@/components/img/home/Etop3.jpg'), id: 2 },
        { url: require('@/components/img/home/Etop4.jpg'), id: 3 },
        { url: require('@/components/img/home/Etop5.jpg'), id: 4 },
        { url: require('@/components/img/home/Etop6.jpg'), id: 5 },
        { url: require('@/components/img/home/Etop7.jpg'), id: 6 },
        { url: require('@/components/img/home/Etop8.jpg'), id: 7 },
        { url: require('@/components/img/home/Etop9.jpg'), id: 8 },
        { url: require('@/components/img/home/Etop10.jpg'), id: 9 },
      ],
      topAZJImage: [
        { url: require('@/components/img/home/AEtop1.jpg'), id: 0 },
        { url: require('@/components/img/home/AEtop2.jpg'), id: 1 },
        { url: require('@/components/img/home/AEtop3.jpg'), id: 2 },
        { url: require('@/components/img/home/AEtop4.jpg'), id: 3 },
        { url: require('@/components/img/home/AEtop5.jpg'), id: 4 },
        { url: require('@/components/img/home/AEtop6.jpg'), id: 5 },
        { url: require('@/components/img/home/AEtop7.jpg'), id: 6 },
        { url: require('@/components/img/home/AEtop8.jpg'), id: 7 },
        { url: require('@/components/img/home/AEtop9.jpg'), id: 8 },
        { url: require('@/components/img/home/AEtop10.jpg'), id: 9 },
      ],
      jtrzList: [
        {
          icon: require('@/components/img/home/image43.png'),
          image: [require('@/components/img/gyhy/zzzs5.png')],
          text: 'アメリカ鉄骨構造協会\nAISC',
          Atext: 'アメリカ鉄骨構造協会\nAISC',
        },
        {
          icon: require('@/components/img/home/image44.png'),
          image: [require('@/components/img/gyhy/zzzs8.png')],
          text: 'アメリカ溶接協会\nAWS',
          Atext: 'アメリカ溶接協会\nAWS',
        },
        {
          icon: require('@/components/img/home/image45.png'),
          image: [require('@/components/img/gyhy/zzzs6.png')],
          text: 'カナダ溶接局\nCWB\nCSA W47.1-D1',
          Atext: 'カナダ溶接局\nCWB\nCSA W47.1-D1',
        },
        {
          icon: require('@/components/img/home/image53.png'),
          image: [require('@/components/img/gyhy/zzzs16.png')],
          text: 'カナダ鋼構造建築システム製造業者認証\nCSA A660-10',
          Atext: 'カナダ鋼構造建築システム製造業者認証\nCSA A660-10',
        },
        {
          icon: require('@/components/img/home/image46.png'),
          image: [require('@/components/img/gyhy/zzzs10-1.png')],
          text: '欧州鉄骨構造製作規格CEマーキング適合\nEN1090-1\nEXC3',
          Atext: '欧州鉄骨構造製作規格CEマーキング適合\nEN1090-1\nEXC3',
        },
        {
          icon: require('@/components/img/home/image46-2.png'),
          image: [require('@/components/img/gyhy/zzzs10-2.png')],
          text: '欧州鉄骨構造製作規格CEマーキング適合\nEN1090-2\nEXC3',
          Atext: '欧州鉄骨構造製作規格CEマーキング適合\nEN1090-2\nEXC3',
        },
        {
          icon: require('@/components/img/home/image48.png'),
          image: [require('@/components/img/gyhy/zzzs9.png')],
          text: '中国鋼構造協会 \n一級製作資格',
          Atext: '中国鋼構造協会 \n一級製作資格',
        },
        {
          icon: require('@/components/img/home/image52.png'),
          image: [require('@/components/img/gyhy/zzzs11.png')],
          text: '欧州金属材料の融接に関する品質要求事項\nISO 3834',
          Atext: '欧州金属材料の融接に関する品質要求事項\nISO 3834',
        },
        {
          icon: require('@/components/img/home/image49.png'),
          image: [
            require('@/components/img/gyhy/zzzs13.png'),
            require('@/components/img/gyhy/zzzs12.png'),
          ],
          text: '欧州品質マネジメントシステムの国際規格\nISO 9001',
          Atext: '欧州品質マネジメントシステムの国際規格\nISO 9001',
        },
        {
          icon: require('@/components/img/home/image50.png'),
          image: [
            require('@/components/img/gyhy/zzzsen2.png'),
            require('@/components/img/gyhy/zzzs2.png'),
            require('@/components/img/gyhy/zzzs4.png'),
          ],
          text: '欧州労働安全衛生マネジメントシステム\nISO 45001',
          Atext: '欧州労働安全衛生マネジメントシステム\nISO 45001',
        },
        {
          icon: require('@/components/img/home/image51.png'),
          image: [
            require('@/components/img/gyhy/zzzsen1.png'),
            require('@/components/img/gyhy/zzzs1.png'),
            require('@/components/img/gyhy/zzzs3.png'),
          ],
          text: '欧州環境マネジメントシステム\nISO 14001',
          Atext: '欧州環境マネジメントシステム\nISO 14001',
        },
        {
          icon: require('@/components/img/home/image47.png'),
          image: [
            require('@/components/img/gyhy/zzzs14.png'),
            require('@/components/img/gyhy/zzzs15.png'),
          ],
          text: '日本鉄骨評価センター国土交通省認定\nJSA H-Grade',
          Atext: '日本鉄骨評価センター国土交通省認定\nJSA H-Grade',
        },
      ],
    }
  },
  created() {
    // 判断设备类型
    this.checkDevice()
  },
  methods: {
    checkDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      const mobileRegex =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
      this.isPC = !mobileRegex.test(userAgent)
    },

    // 只预加载当前设备的轮播图
    async preloadImages() {
      const imageList = this.isPC ? this.topPCJImage : this.topAZJImage
      const promises = imageList.map((item) => {
        return new Promise((resolve) => {
          const img = new Image()
          img.src = item.url
          img.onload = resolve
          img.onerror = resolve
        })
      })
      await Promise.all(promises)
    },
  },
  mounted() {
    this.preloadImages()
  },
}
</script>
<style scoped>
.titleTo {
  font-size: 15px;
  color: #ccc;
  text-align: center;
  margin: 20px 0 -30px 0;
  cursor: pointer;
}
.full-screen-portfolio {
  background-color: #e7e7e8;
  padding: 40px 80px;
}
.hover-content {
  height: 120px;
}
.hover-content h1 {
  margin: 10px 0;
}

/* line */
.ul::before {
  content: '';
  grid-column: 1;
  grid-row: 1 / span 20;
  background: rgb(225, 225, 225);
  border-radius: calc(var(--line-w) / 2);
}

/*轮播图*/
.topSwiper {
  z-index: 9999;
  height: calc(100vh - 80px);
  width: 100%;
}
div /deep/ .el-carousel__container {
  height: calc(100vh - 80px);
}

div /deep/ .el-carousel__indicators--horizontal {
  bottom: 20px;
}

div /deep/ .el-carousel__button {
  height: 10px;
}

.el-carousel__item h3 {
  opacity: 1;
  margin: 0;
  text-align: center;
}
.el-carousel__item h3 span {
  z-index: 999;
  display: inline-block;
  width: fit-content;
  position: absolute;
  height: 80px;
  bottom: 10%;
  left: 50%;
  transform: translate(-50%, 0);
  color: #fff;
  font-size: 50px;
  text-align: center;
  letter-spacing: 1.5px;
  font-weight: 400;
  line-height: 80px;
}

.sImg img {
  width: 100%;
  height: calc(100vh - 80px);
}

.double-border {
  width: auto;
  position: relative;
  border: 2px solid #fff;
  padding: 5px;
}
/* 外邊框樣式 */
.double-border::before {
  content: '';
  position: absolute;
  width: 40px;
  height: 40px;
  transition: 0.3s ease-in-out;
  top: -8px;
  left: -8px;
  border-top: 2px solid #fff;
  border-left: 2px solid #fff;
}
.double-border::after {
  content: '';
  position: absolute;
  width: 40px;
  height: 40px;
  transition: 0.3s ease-in-out;
  right: -8px;
  bottom: -8px;
  border-bottom: 2px solid #fff;
  border-right: 2px solid #fff;
}
.box {
  z-index: 999;
  display: inline-block;
  width: fit-content;
  position: absolute;
  height: 80px;
  bottom: 10%;
  left: 50%;
  transform: translate(-50%, 0);
  width: 80vw;
  height: 100px;
  background-color: rgba(192, 192, 192, 0.7);
}
/*/~ 重置轮播动画 ~/
.el-carousel__item {
  transition: transform 0.8s cubic-bezier(0.23, 1, 0.32, 1) !important;
}*/

.col-lg-2 {
  padding-left: 5px;
  padding-right: 5px;
}

.eImagebc {
  width: 100%;
  background-color: #fff;
  border: 2px solid #ccc;
}

@media screen and (max-width: 1400px) {
  .full-screen-portfolio .portfolio-item h1 {
    font-size: 18px;
    font-weight: normal;
  }
  .swiper-container {
    width: 100%;
    height: 300px;
    position: relative;
  }
  .swip {
    height: 300px;
  }
  .swiper-image {
    width: 100vw;
    height: 300px;
  }
  .overlay {
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 5px;
    border-radius: 10px;
    color: white;
  }
  .altitle {
    font-size: 15px;
    margin-bottom: 10px;
  }
  .text {
    font-size: 10px;
    margin: 10px 0;
  }
  .details {
    font-size: 13px;
    background-color: rgba(255, 255, 255, 0.3);
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;
  }
  .scrm {
    padding: 0 5px;
  }
  .ryfox {
    padding: 0 10px;
  }
  .hover-content h1 {
    margin: 10px 0 0 0;
  }
  #about h3 {
    font-size: 26px;
  }
  .topSwiper {
    height: calc(100vh - 80px);
  }
  div /deep/ .el-carousel__container {
    height: calc(100vh - 80px);
  }

  div /deep/ .el-carousel__indicators--horizontal {
    bottom: 7px;
    width: max-content;
  }

  div /deep/ .el-carousel__button {
    width: 20px;
    height: 7px;
  }
  .sImg img {
    width: 100%;
    height: calc(100vh - 80px);
  }
  #about {
    padding: 40px 0 60px 0;
  }
  #about .lead {
    font-size: 18px;
    line-height: 2;
    color: #000;
    width: 90vw;
    margin: 10px auto;
  }
  .new-scheme-main {
    width: 100%;
    padding: 40px 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .full-screen-portfolio {
    padding: 15px 40px;
  }
  .full-screen-portfolio .portfolio-item h1 {
    line-height: 25px;
  }
  div /deep/ .portfolio-item img {
    height: 24vw;
  }
  .hover-content {
    height: 100px;
  }
  .new-scheme-main .title {
    font-size: 25px;
  }
}

@media screen and (max-width: 768px) {
  .full-screen-portfolio .portfolio-item h1 {
    font-size: 13px;
    font-weight: normal;
  }
  .swiper-container {
    width: 100%;
    height: 300px;
    position: relative;
  }
  .swip {
    height: 300px;
  }
  .swiper-image {
    width: 100vw;
    height: 300px;
  }
  .overlay {
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 5px;
    border-radius: 10px;
    color: white;
  }
  .altitle {
    font-size: 13px;
    margin-bottom: 10px;
  }
  .text {
    font-size: 10px;
    margin: 10px 0;
  }
  .details {
    font-size: 13px;
    background-color: rgba(255, 255, 255, 0.3);
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;
  }
  .scrm {
    padding: 0 5px;
  }
  .ryfox {
    padding: 0 2px;
  }
  .hover-content h1 {
    margin: 5px 0;
  }
  #about h3 {
    font-size: 22px;
  }
  .topSwiper {
    height: calc(100vh - 56px);
  }
  div /deep/ .el-carousel__container {
    height: calc(100vh - 56px);
  }

  div /deep/ .el-carousel__indicators--horizontal {
    bottom: 10px;
    width: max-content;
  }

  div /deep/ .el-carousel__button {
    width: 15px;
    height: 5px;
  }
  .sImg img {
    width: 100%;
    height: calc(100vh - 56px);
  }
  #about {
    padding: 50px 0 60px 0;
  }
  #about .lead {
    font-size: 13px;
    line-height: 2;
    color: #000;
    width: 90vw;
    margin: 10px auto;
  }
  .new-scheme-main {
    width: 100%;
    padding: 40px 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .full-screen-portfolio {
    padding: 10px 5px;
  }
  .full-screen-portfolio .portfolio-item h1 {
    line-height: 20px;
  }
  div /deep/ .portfolio-item img {
    height: 100px;
  }
  .hover-content {
    height: 100px;
  }
  .new-scheme-main .title {
    font-size: 22px;
  }
}
@media screen and (min-width: 2000px) {
  .full-screen-portfolio .portfolio-item h1 {
    font-size: 26px;
    font-weight: normal;
  }
  .ryfox {
    padding: 0 10px;
  }
  .hover-content h1 {
    margin: 10px 0 0 0;
  }
  #about h3 {
    font-size: 40px;
  }
  .topSwiper {
    height: calc(100vh - 80px);
  }
  div /deep/ .el-carousel__container {
    height: calc(100vh - 80px);
  }

  div /deep/ .el-carousel__indicators--horizontal {
    bottom: 7px;
    width: max-content;
  }

  div /deep/ .el-carousel__button {
    width: 20px;
    height: 7px;
  }
  .sImg img {
    width: 100%;
    height: calc(100vh - 80px);
  }
  #about .lead {
    font-size: 30px;
    line-height: 2;
    color: #000;
  }
  .new-scheme-main {
    width: 100%;
    padding: 90px 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .full-screen-portfolio {
    padding: 60px 100px;
  }
  .full-screen-portfolio .portfolio-item h1 {
    line-height: 30px;
  }
  div /deep/ .portfolio-item img {
    height: 13vw;
  }
  .hover-content {
    height: 120px;
  }
  .new-scheme-main .title {
    font-size: 40px;
  }
}
</style>
